/**
 *
 *
 * @author Erik Jan Lam
 * @date Jan 17 2019
 */

var urlUtil = require('../utils/url');
var slider = require('./slider');
var offcanvasdialog = require('../../components/offcanvasdialog');
var flyinInstance;

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
var addItemToCart = function (form) {
    var $form = $(form);
    var $qty = $form.find('[name="Quantity"]');
    var selectedQty = '1';

    if (isNaN($qty.val()) || parseInt($qty.val(), 10) === 0) {
        $qty.val(selectedQty);
    }

    return $.ajax({
        type: 'POST',
        url: urlUtil.appendParamsToUrl(urlUtil.ajaxUrl(Urls.addProduct), {collaboration: 'true'}),
        data: $form.serialize()
    });
};

var showCartAddedConfirmation = function (content) {
    if (!flyinInstance) {
        flyinInstance = offcanvasdialog.init(
            false,
            {
                overlay: true,
                overlayClasses: 'is-active',
                additionalClass: 'cart-fly-in quickshop-fly-in',
                beforeShow: function ($flyinContainer) {
                    // add overlay.
                    if (!flyinInstance.$overlay || !flyinInstance.$overlay.length) {
                        var $overlay = $('<div class="quickshop-overlay" id="quickshop-overlay"/>');
                        $overlay.insertAfter($flyinContainer);
                        flyinInstance.$overlay = $overlay;
                    }

                    this.setOptions({additionalClass: 'cart-fly-in quickshop-fly-in'});

                    $flyinContainer.find('.flyin-close').on('click', function (event) {
                        event.preventDefault();
                        flyinInstance.hide();
                    });
                }
            },
            function ($triggerButton, $flyinContainer) {
                var $container = $flyinContainer.find('.ocd-content');
                if ($container.length) {
                    // init cart flyin.
                    var relatedProducts = $container.find('ul.carousel')[0];
                    if (relatedProducts) {
                        slider.init(relatedProducts, {
                            dots: true,
                            arrows: true,
                            slidesToShow: 2
                        });
                    }
                }
            }
        );
    }

    flyinInstance.$content = content;
    flyinInstance.loadContent(content, function () {
        flyinInstance.show();
    });
};

exports.addItemToCart = addItemToCart;
exports.showCartAddedConfirmation = showCartAddedConfirmation;
